export default __webpack_public_path__ + "static/media/joinMemberBg.92ca016f.png";